const IMG_BASE = "w-full object-cover transition-transform duration-[1200ms] ease-out";

const WorkImage = ({ src, sizing }) => (
  <div className="overflow-hidden">
    <img
      src={src}
      alt="Medium Plenty work"
      loading="lazy"
      className={`${IMG_BASE} ${sizing}`}
      style={{ filter: "grayscale(6%)" }}
    />
  </div>
);

export const WorkRow = ({ row }) => {
  if (row.type === "full") {
    return <WorkImage src={row.imgs[0]} sizing="h-[52vh] md:h-[86vh] hover:scale-[1.02]" />;
  }
  return (
    <div className="grid md:grid-cols-2 gap-4 md:gap-6">
      {row.imgs.map((src) => (
        <WorkImage key={src} src={src} sizing="h-[42vh] md:h-[62vh] hover:scale-[1.03]" />
      ))}
    </div>
  );
};
